<template>
  <div class="animated fadeIn">
    <b-modal ref="my-modal" size="lg" hide-footer title="COMPLEMENTO">
      <Forms ref="frmComplement"
      :title="'CADASTRO DE COMPLEMENTO'"
      :showHelp="false"
      :showClearButton="isCompleted ? false : true"
      :showSaveButton="isCompleted ? false : true"
      v-on:Clear="onClear"
      v-on:Save="onSave">
        <div class="form-group row">
          <div class="col-md-6">
          <label for="txtComplementaryBudgetedLabor">Mão de Obra Orçado:</label>
          <div class="input-group">
            <span class="input-group-addon"><i class="fa fa-dollar"></i></span>
            <money name="txtComplementaryBudgetedLabor"
                class="form-control form-control-10 text-right"
                v-bind="moneyFormat"
                :placeholder="'0,00'"
                prefix="R$ "
                v-model="form.budgetedLabor.value"
                :size="form.budgetedLabor.maxlength"
                :required="form.budgetedLabor.required"
                :state="form.budgetedLabor.state"
                :disabled="isCompleted">
            </money>
          </div>
        </div>
        <div class="col-md-6">
          <label for="txtComplementaryApprovedLabor">Peças Orçadas:</label>
          <div class="input-group">
            <span class="input-group-addon"><i class="fa fa-dollar"></i></span>
            <money name="txtComplementaryApprovedLabor"
                class="form-control form-control-10 text-right"
                v-bind="moneyFormat"
                :placeholder="'0,00'"
                prefix="R$ "
                v-model="form.approvedLabor.value"
                :size="form.approvedLabor.maxlength"
                :required="form.approvedLabor.required"
                :state="form.approvedLabor.state"
                :disabled="isCompleted">
            </money>
          </div>
        </div>
        </div>
      </Forms>
    </b-modal>
  </div>
</template>
<script>
import ActionsForm from '@/shared/mixins/actionsForm'
import { loading, toast } from '@/shared/utils/UIHelper'
import ModalSinisterTypingForm from './modalsinistertyping-form.js'
import ModalSinisterTypingModel from './modalsinistertyping-model.js'

import RegulationAutoDigitationComplementary from '@/shared/http/repositories/regulation/auto/regulationautotypingcomplement.js'
import RegulationMixin from '@/store/module/regulation/mixin'
import PermissionMixin from '@/store/module/permission/mixin'

export default {
  name: 'ModalSinisterTyping',
  mixins: [ActionsForm, RegulationMixin, PermissionMixin],
  data () {
    return {
      data: ModalSinisterTypingModel,
      form: ModalSinisterTypingForm,
      regulationID: null,
      objSelected: null,
      moneyFormat: {
        decimal: ',',
        thousands: '.',
        prefix: '',
        suffix: '',
        precision: 2,
        masked: false
      }
    }
  },
  methods: {
    formatPrice (value) {
      let val = (value / 1).toFixed(2).replace('.', ',')
      return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.')
    },
    showModal (regulationID) {
      this.$refs['my-modal'].show()
      this.form.budgetedLabor.value = 0
      this.form.approvedLabor.value = 0
      this.regulationID = regulationID
    },
    hideModal () {
      this.$refs['my-modal'].hide()
    },
    editShoModal (obj, isCompleted) {
      this.$refs['my-modal'].show()
      if (obj) {
        this.objSelected = obj
        this.isCompleted = isCompleted
        this.data = obj
        this.form.budgetedLabor.value = obj.budgetedLabor || 0
        this.form.approvedLabor.value = obj.approvedLabor || 0
      }
    },
    onCreate () {
      loading.push()
      this.data.regulationAutoID = this.regulationID
      RegulationAutoDigitationComplementary.Create(this.data)
        .then((response) => {
          loading.close()
          this.$emit('Reload')
          this.hideModal()
          if (response.data.code >= 0) {
            toast.success(this.$lang.Common.Alerts.Success)
          }
        })
        .catch(this.onException)
    },
    onUpdate () {
      if (!this.isCompleted) {
        loading.push()
        RegulationAutoDigitationComplementary.Update(this.data)
          .then((response) => {
            loading.close()
            this.$emit('Reload')
            this.hideModal()
            if (response.data.code >= 0) {
              toast.success(this.$lang.Common.Alerts.Success)
            }
          })
          .catch(this.onException)
      } else {
        toast.warning('Não foi possível atualizar, vistoria já finalizada!')
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/private/inspection/typing/modal/modalsinistertyping.vue